import { Component, OnInit, Inject } from '@angular/core';
import { MdDialogRef, MD_DIALOG_DATA } from '@angular/material';
import { JobsOffer } from '../../models/jobs-offer';

@Component({
  selector: 'app-view-cv',
  templateUrl: './view-cv.component.html',
  styleUrls: ['./view-cv.component.css']
})

export class ViewCvComponent implements OnInit {

  userId:string;
  job:JobsOffer;

  constructor(public dialogRef: MdDialogRef<ViewCvComponent>,
              @Inject(MD_DIALOG_DATA) public data: any) {
    this.userId = data.userId;
    this.job = data.job;
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/view-cv/view-cv.component.ts